<box-chips *ngIf="activeFilteringOptions?.length">
  <box-chip *ngFor="let filter of activeFilteringOptions">
    <img *ngIf="filter.type === 'dietary'" boxChipImage [src]="filter.icon" [alt]="filter.label" />
    {{ filter.shortLabel }}
    <button boxChipRemove mat-icon-button (click)="onRemoveFilter(filter)">
      <mat-icon>close</mat-icon>
    </button>
  </box-chip>
</box-chips>
